<template>
  <div
    class="people__list grid-container"
    :class="people_list.length === 1 ? 'grid-container--one' : 'grid-container--two'"
  >
    <AppPeopleItem v-for="people in people_list" :key="people.id" :people_item="people"/>
  </div>
</template>

<script>
  import AppPeopleItem from '@/components/People/PeopleItem.vue'

  export default {
    name: "AppDoctorsPeopleList",
    components: { AppPeopleItem },
    props: {
      people_list: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
      };
    }
  };
</script>

